"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("react-query");
var _utils = require("../utils");
const useInvalidateRefdata = desc => {
  const queryClient = (0, _reactQuery.useQueryClient)();
  return () => queryClient.invalidateQueries((0, _utils.refdataQueryKey)(desc));
};
var _default = exports.default = useInvalidateRefdata;